import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "./../../../../assets/css/purchase/form.css";
import { manageWhItemData } from "../../../../utils/WarehouseUtils";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import CurrencyInput from "react-currency-input-field";
import {
  deleteData,
  getAlert,
  getDataWithComp,
  getDataWithJoin,
  insertData,
  updateData,
  getData,
  formatCurrency,
  parseCurrency,
} from "../../../../utils/SamuiUtils";
import { getCreateDateTime2 } from "../../../../utils/DateUtils";
import { useNavigate } from "react-router-dom";
import ItemTable from "../../../components/Content/ItemTableAddItem";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  setSelectedData,
  setMode,
}) => {
  console.debug("formData", formData);
  console.debug("selectedData", selectedData);
  const [initialFormData, setInitialFormData] = useState({});
  const [whDataList, setWhDataList] = useState([]);
  const [unitDataList, setUnitDataList] = useState([]);
  const [brandDataList, setBrandDataList] = useState([]);
  const [groupDataList, setGroupDataList] = useState([]);
  const [catDataList, setCatDataList] = useState([]);
  const [sizeDataList, setSizeDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [onhandMap, setOnhandMap] = useState({});

  const [formDetailList, setFormDetailList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [showItemModal, setShowItemModal] = useState(false);

  const [showSubItemTable, setShowSubItemTable] = useState(false);
  const [showSubItemTable2, setShowSubItemTable2] = useState(false);
  const [isSaveAsMode, setIsSaveAsMode] = useState(false); // เพิ่ม flag สำหรับ SaveAS
  const [saveAsCompleted, setSaveAsCompleted] = useState(false); // flag ว่า SaveAS เสร็จแล้ว
  const [showItemCodeModal, setShowItemCodeModal] = useState(false); // modal สำหรับกรอกรหัสสินค้าใหม่
  const [newItemCode, setNewItemCode] = useState(""); // รหัสสินค้าใหม่ที่จะกรอก
  const saveAsDataRef = useRef(null); // เก็บข้อมูลสำหรับ SaveAS
  console.debug("showSubItemTable:", showSubItemTable);
  console.debug("whDataList:", whDataList);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("whDataList", whDataList)
  }, [whDataList])

  const initialize = async () => {
    try {
      const unitDataList = await getDataWithComp(
        "Tb_Set_Unit",
        `AND Unit_Status = 'Y' ORDER BY Unit_Id ASC`
      );
      if (unitDataList && unitDataList.length > 0) {
        // setUnitDataList([])
        setUnitDataList(unitDataList);
      }
      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_WH
      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );
      if (whDataList && whDataList.length > 0) {
        // setWhDataList([])
        setWhDataList(whDataList);
      }
      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmBrand
      const brandDataList = await getDataWithComp(
        "Tb_Set_ItmBrand",
        `AND Brand_Status = 'Y' ORDER BY Brand_Id ASC`
      );
      if (brandDataList && brandDataList.length > 0) {
        // setWhDataList([])
        setBrandDataList(brandDataList);
      }

      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmGroup
      const groupDataList = await getDataWithComp(
        "Tb_Set_ItmGroup",
        `AND Group_Status = 'Y' ORDER BY Group_Id ASC`
      );
      if (groupDataList && groupDataList.length > 0) {
        // setWhDataList([])
        setGroupDataList(groupDataList);
      }

      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmGroup
      // const colourDataList = await getDataWithComp(
      //   "Tb_Set_ItmColour",
      //   `AND Colour_Status = 'Y' ORDER BY Colour_Id ASC`
      // );
      // if (colourDataList && colourDataList.length > 0) {
      //   // setWhDataList([])
      //   setColourDataList(colourDataList);
      // }

      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmCat
      const whereClause = `Cat_Status = 'Y'`;
      const catDataList = await getData("Tb_Set_ItmCat", whereClause);
      // const catDataList = await getDataWithComp('Tb_Set_ItmCat', `AND Cat_Code = 'Y' ORDER BY Cat_Id asc `);
      console.debug("catDataList:", catDataList);
      if (catDataList && catDataList.length > 0) {
        // setWhDataList([])
        setCatDataList(catDataList);
      }
      // ค้นหาข้อมูลตั้งต้นจาก Tb_Set_ItmGroup
      const sizeDataList = await getDataWithComp(
        "Tb_Set_ItmSize",
        `AND Size_Status = 'Y' ORDER BY Size_Id ASC`
      );
      console.debug("sizeDataList:", sizeDataList);
      if (sizeDataList && sizeDataList.length > 0) {
        // setWhDataList([])
        setSizeDataList(sizeDataList);
      }

      const apDataList = await getDataWithComp(
        "Tb_Set_AP",
        ` ORDER BY AP_Id ASC`
      );
      if (apDataList && apDataList.length > 0) {
        // setWhDataList([])
        console.debug("apDataList:", apDataList);
        setApDataList(apDataList);
      }

      const itemList = await getDataWithComp(
        "Tb_Set_Item",
        "AND Item_Status = 'Y' ORDER BY Item_Code ASC"
      );
      if (itemList && itemList.length > 0) {
        setItemDataList(itemList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const loadItemBOMList = async (proId) => {
    console.debug("hi loadItemBOMList");
    try {
      const whereClause = `AND pro_id = ${proId}`;
      const res = await getDataWithComp("Tb_Set_ItemBOM", whereClause);
      console.debug("res", res);
      if (res && res.length > 0) {
        const mappedList = res.map((row) => {
          const itemData = itemDataList.find(
            (item) => item.Item_Id === row.item_id
          );

          return {
            line: row.line,
            itemId: row.item_id,
            itemCode: itemData?.Item_Code || "",
            itemName: itemData?.Item_Name || "",
            itemQty: formatCurrency(row.quantity),
            itemUnit: itemData?.Item_Unit_ST || "",
            itemPriceUnit: formatCurrency(itemData?.Item_Price || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemData?.Item_Status || "Y",
            whId: null,
            whName: itemData?.WH_Name || "",
            zoneId: null,
            ltId: null,
            dsSeq: null,
          };
        });
        setFormDetailList(mappedList);
      }
      setShowSubItemTable(true);
      console.debug("formData.is_bom5", formData.is_bom);
    } catch (error) {
      console.error("loadItemBOMList error:", error);
      getAlert("FAILED", "โหลดข้อมูล BOM ไม่สำเร็จ");
    }
  };

  const loadItemSubList = async (proId) => {
    console.debug("hi loadItemSubList");
    try {
      const whereClause = `AND item_id = ${proId}`;
      const res = await getDataWithComp("Tb_Set_ItemSub", whereClause);
      console.debug("res", res);
      if (res && res.length > 0) {
        const mappedList = res.map((row) => {
          const itemData = itemDataList.find(
            (item) => item.Item_Id === row.subitem_id
          );
          console.debug("itemData", itemData);

          return {
            line: row.line,
            itemId: row.item_id,
            itemCode: itemData?.Item_Code || "",
            itemName: itemData?.Item_Name || "",
            itemQty: formatCurrency(row.subitem_qty),
            itemUnit: itemData?.Item_Unit_ST || "",
            itemPriceUnit: formatCurrency(itemData?.Item_Price || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemData?.Item_Status || "Y",
            whId: null,
            whName: itemData?.WH_Name || "",
            zoneId: null,
            ltId: null,
            dsSeq: null,
          };
        });
        setFormDetailList(mappedList);
      }
      setShowSubItemTable2(true);
      console.debug("formData.is_sub_item", formData.is_sub_item);
    } catch (error) {
      console.error("loadItemBOMList error:", error);
      getAlert("FAILED", "โหลดข้อมูล BOM ไม่สำเร็จ");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    console.log("=== handleChange ===", { name, value, mode, isSaveAsMode });

    // ป้องกันการเปลี่ยนแปลงเมื่ออยู่ในโหมด SaveAS
    if (isSaveAsMode && saveAsDataRef.current) {
      console.log("ป้องกันการเปลี่ยนแปลงเนื่องจากอยู่ในโหมด SaveAS");
      return;
    }

    if (
      mode === "U" &&
      name === "item_group" &&
      initialFormData.item_group === "3" &&
      value !== "3" &&
      formDetailList.length > 0
    ) {
      getAlert(
        "C_DIALOG",
        "การเปลี่ยนกลุ่มสินค้าจะทำให้รายการ BOM หาย ต้องการดำเนินการต่อหรือไม่?",
        (isConfirm) => {
          if (isConfirm) {
            setFormData((prev) => ({
              ...prev,
              [name]: value,
            }));
            setFormDetailList([]);
          }
        }
      );
      return;
    }

    if (name === "item_unit_in") {
      setFormData((prev) => ({
        ...prev,
        item_unit_in: value,
        item_unit_st: prev.item_unit_st || value,
        item_unit_out: prev.item_unit_out || value,
      }));
      return;
    }

    if (name === "item_unit_st") {
      setFormData((prev) => ({
        ...prev,
        item_unit_st: value,
        item_unit_out: value,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCurrencyChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertTbsetItem = async () => {
    try {
      // ตรวจสอบรหัสสินค้าซ้ำ
      const isDuplicate = await checkItemCodeDuplicate(formData.item_code);
      if (isDuplicate) {
        getAlert("FAILED", "รหัสสินค้านี้มีอยู่แล้ว กรุณาใช้รหัสอื่น");
        return { status: "FAILED", message: "Duplicate Item Code" };
      }

      const { item_id, ...dataToInsert } = formData;
      const sanitizeData = (data) => {
        const sanitized = { ...data };

        // แปลงค่าที่เป็น string ว่างให้เป็น 0 สำหรับฟิลด์ตัวเลข
        sanitized.Item_Cost =
          data.item_cost === "" ? 0 : parseFloat(data.item_cost);
        sanitized.Item_Price =
          data.item_price === "" ? 0 : parseFloat(data.item_price);
        sanitized.Item_PriceA =
          data.item_pricea === "" ? 0 : parseFloat(data.item_pricea);
        sanitized.Item_PriceB =
          data.item_priceb === "" ? 0 : parseFloat(data.item_priceb);
        sanitized.Item_PoPoint =
          data.item_popoint === "" ? 0 : parseInt(data.item_popoint);
        sanitized.Item_MaxOnhand =
          data.item_maxonhand === "" ? 0 : parseInt(data.item_maxonhand);
        sanitized.Item_Gold =
          data.item_gold === "" ? 0 : parseFloat(data.item_gold);
        sanitized.Item_Onhand =
          data.item_onhand === "" ? 0 : parseFloat(data.item_onhand);
        sanitized.Item_Group =
          data.item_group === "" ? 1 : parseInt(data.item_group);

        // แปลง Boolean → 'Y' / 'N' สำหรับ CHAR(1)
        sanitized.Is_BOM = data.is_bom ? "Y" : "N";
        sanitized.Is_Sub_Item = data.is_sub_item ? "Y" : "N";
        sanitized.Is_Spec_Show = data.show_spec ? "Y" : "N";

        // Map ชื่อ field ให้ตรง DB (case sensitive)
        sanitized.Comp_Id = parseInt(data.comp_id);
        sanitized.Item_Barcode = data.item_barcode || "";
        sanitized.Item_Code = data.item_code || "";
        sanitized.Item_Name = data.item_name || "";
        sanitized.Item_Name_EN = data.item_name_en || "";
        sanitized.Item_Short_Name = data.item_short_name || "";
        sanitized.Item_Unit_IN = data.item_unit_in || "";
        sanitized.Item_Unit_ST = data.item_unit_st || "";
        sanitized.Item_Unit_OUT = data.item_unit_out || "";
        sanitized.Item_Brand = data.item_brand || "";
        sanitized.Item_Series = data.item_series || "";
        sanitized.Item_Cat = data.item_cat || "";
        sanitized.Item_Colour = data.item_colour || "";
        sanitized.Item_Size = data.item_size || "";
        sanitized.Item_Status = data.item_status || "Y";
        sanitized.AP_Code = data.ap_code || "";
        sanitized.Item_WH = data.item_wh || "";
        sanitized.Item_AP_id = data.item_ap_id
          ? parseInt(data.item_ap_id)
          : null;
        sanitized.Item_Spec = data.item_Spec || "";

        sanitized.Item_Qty_IN =
          data.item_qty_in === "" ? 0 : parseFloat(data.item_qty_in);
        sanitized.Item_Qty_ST =
          data.item_qty_st === "" ? 0 : parseFloat(data.item_qty_st);
        sanitized.Item_Qty_Out =
          data.item_qty_out === "" ? 0 : parseFloat(data.item_qty_out);

        // ลบ key ที่ไม่ตรงชื่อจริง
        delete sanitized.item_cost;
        delete sanitized.item_price;
        delete sanitized.item_pricea;
        delete sanitized.item_priceb;
        delete sanitized.item_popoint;
        delete sanitized.item_maxonhand;
        delete sanitized.item_gold;
        delete sanitized.item_onhand;
        delete sanitized.item_group;
        delete sanitized.is_bom;
        delete sanitized.is_sub_item;
        delete sanitized.show_spec;
        delete sanitized.comp_id;
        delete sanitized.item_barcode;
        delete sanitized.item_code;
        delete sanitized.item_name;
        delete sanitized.item_name_en;
        delete sanitized.item_short_name;
        delete sanitized.item_unit_in;
        delete sanitized.item_unit_st;
        delete sanitized.item_unit_out;
        delete sanitized.item_brand;
        delete sanitized.item_series;
        delete sanitized.item_cat;
        delete sanitized.item_colour;
        delete sanitized.item_size;
        delete sanitized.item_status;
        delete sanitized.ap_code;
        delete sanitized.item_wh;
        delete sanitized.item_ap_id;
        delete sanitized.item_Spec;
        delete sanitized.item_qty_in;
        delete sanitized.item_qty_st;
        delete sanitized.item_qty_out;

        return sanitized;
      };

      const sanitizedData = sanitizeData(dataToInsert);

      const fields = Object.keys(sanitizedData).join(", ");
      const values = Object.values(sanitizedData);

      const res = await insertData("Tb_Set_Item", fields, values);
      console.debug("res", res);
      if (res?.status === "OK") {
        const newItemId = res?.result?.recordset?.[0]?.insertedId;
        const createdBy = localStorage.getItem("name");
        if (showSubItemTable === true) {
          await insertItemBOMList(newItemId, createdBy);
        } else if (showSubItemTable2 === true) {
          await insertItemSubList(
            newItemId,
            formDetailList[0].itemId,
            createdBy
          );
        } else {
          getAlert("OK", "บันทึกข้อมูลสำเร็จ");
          callInitialize();
        }
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
      return res; // เพิ่มบรรทัดนี้ เพื่อให้ handleSubmit ใช้งานได้
    } catch (error) {
      console.error("Error inserting data:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return { status: "FAILED", message: error.message }; // เพิ่ม return กรณี error
    }
  };

  const insertItemBOMList = async (proId, createdBy) => {
    const compId = parseInt(localStorage.getItem("company"), 10);
    const now = getCreateDateTime2();

    let allSuccess = true;

    for (let i = 0; i < formDetailList.length; i++) {
      const item = formDetailList[i];

      const fields = [
        "comp_id",
        "pro_id",
        "item_id",
        "quantity",
        "line",
        "created_by",
        "created_date",
        "updated_by",
        "updated_date",
      ].join(", ");

      const values = [
        compId,
        proId,
        item.itemId,
        parseFloat(item.itemQty || "0"),
        i + 1,
        createdBy,
        now,
        createdBy,
        now,
      ];

      const res = await insertData("Tb_Set_ItemBOM", fields, values);
      if (res?.status !== "OK") {
        allSuccess = false;
      }
    }

    if (allSuccess) {
      getAlert("OK", "บันทึกข้อมูลสำเร็จ");
      callInitialize();
    } else {
      getAlert("FAILED", "บางรายการใน BOM บันทึกไม่สำเร็จ");
    }
  };

  const insertItemSubList = async (proId, sub_id, createdBy) => {
    console.debug("insertItemSubList", proId, sub_id);
    const compId = parseInt(localStorage.getItem("company"), 10);
    let allSuccess = true;

    for (let i = 0; i < formDetailList.length; i++) {
      const item = formDetailList[i];

      const fields = ["item_id", "subitem_id", "subitem_qty", "comp_id"].join(
        ", "
      );

      const values = [
        proId, // main item_id
        sub_id, // sub item id
        parseFloat(item.itemQty || "0"), // qty
        compId,
      ];

      const res = await insertData("Tb_Set_ItemSub", fields, values);
      if (res?.status !== "OK") {
        allSuccess = false;
      }
    }

    if (allSuccess) {
      getAlert("OK", "บันทึกข้อมูลสำเร็จ");
      callInitialize();
    } else {
      getAlert("FAILED", "บางรายการบันทึกไม่สำเร็จ");
    }
  };

  const handleUpdateTbsetItem = async () => {
    try {
      // ตรวจสอบรหัสสินค้าซ้ำ (ยกเว้นตัวเอง)
      const isDuplicate = await checkItemCodeDuplicate(
        formData.item_code,
        formData.item_id
      );
      if (isDuplicate) {
        getAlert("FAILED", "รหัสสินค้านี้มีอยู่แล้ว กรุณาใช้รหัสอื่น");
        return { status: "FAILED", message: "Duplicate Item Code" };
      }

      const sanitizeData = (data) => {
        const sanitized = { ...data };

        // แปลงค่าที่เป็น string ว่างให้เป็น 0 สำหรับฟิลด์ตัวเลข
        sanitized.Item_Cost =
          data.item_cost === "" ? 0 : parseFloat(data.item_cost);
        sanitized.Item_Price =
          data.item_price === "" ? 0 : parseFloat(data.item_price);
        sanitized.Item_PriceA =
          data.item_pricea === "" ? 0 : parseFloat(data.item_pricea);
        sanitized.Item_PriceB =
          data.item_priceb === "" ? 0 : parseFloat(data.item_priceb);
        sanitized.Item_PoPoint =
          data.item_popoint === "" ? 0 : parseInt(data.item_popoint);
        sanitized.Item_MaxOnhand =
          data.item_maxonhand === "" ? 0 : parseInt(data.item_maxonhand);
        sanitized.Item_Gold =
          data.item_gold === "" ? 0 : parseFloat(data.item_gold);
        sanitized.Item_Onhand =
          data.item_onhand === "" ? 0 : parseFloat(data.item_onhand);
        sanitized.Item_Group =
          data.item_group === "" ? 1 : parseInt(data.item_group);

        // แปลง Boolean → 'Y' / 'N' สำหรับ CHAR(1)
        sanitized.Is_BOM = data.is_bom ? "Y" : "N";
        sanitized.Is_Sub_Item = data.is_sub_item ? "Y" : "N";
        sanitized.Is_Spec_Show = data.show_spec ? "Y" : "N";

        // Map ชื่อ field ให้ตรง DB (case sensitive)
        sanitized.Comp_Id = parseInt(data.comp_id);
        sanitized.Item_Barcode = data.item_barcode || "";
        sanitized.Item_Code = data.item_code || "";
        sanitized.Item_Name = data.item_name || "";
        sanitized.Item_Name_EN = data.item_name_en || "";
        sanitized.Item_Short_Name = data.item_short_name || "";
        sanitized.Item_Unit_IN = data.item_unit_in || "";
        sanitized.Item_Unit_ST = data.item_unit_st || "";
        sanitized.Item_Unit_OUT = data.item_unit_out || "";
        sanitized.Item_Brand = data.item_brand || "";
        sanitized.Item_Series = data.item_series || "";
        sanitized.Item_Cat = data.item_cat || "";
        sanitized.Item_Colour = data.item_colour || "";
        sanitized.Item_Size = data.item_size || "";
        sanitized.Item_Status = data.item_status || "Y";
        sanitized.AP_Code = data.ap_code || "";
        sanitized.Item_WH = data.item_wh || "";
        sanitized.Item_AP_id = data.item_ap_id
          ? parseInt(data.item_ap_id)
          : null;
        sanitized.Item_Spec = data.item_Spec || "";
        if (
          data.item_sprice_use !== undefined &&
          data.item_sprice_use !== null
        ) {
          sanitized.Item_SPrice_use = data.item_sprice_use ? "Y" : "N";
        }

        // ลบ key ที่ไม่ตรงชื่อจริง
        delete sanitized.item_cost;
        delete sanitized.item_price;
        delete sanitized.item_pricea;
        delete sanitized.item_priceb;
        delete sanitized.item_popoint;
        delete sanitized.item_maxonhand;
        delete sanitized.item_gold;
        delete sanitized.item_onhand;
        delete sanitized.item_group;
        delete sanitized.is_bom;
        delete sanitized.is_sub_item;
        delete sanitized.show_spec;
        delete sanitized.comp_id;
        delete sanitized.item_barcode;
        delete sanitized.item_code;
        delete sanitized.item_name;
        delete sanitized.item_name_en;
        delete sanitized.item_short_name;
        delete sanitized.item_unit_in;
        delete sanitized.item_unit_st;
        delete sanitized.item_unit_out;
        delete sanitized.item_brand;
        delete sanitized.item_series;
        delete sanitized.item_cat;
        delete sanitized.item_colour;
        delete sanitized.item_size;
        delete sanitized.item_status;
        delete sanitized.ap_code;
        delete sanitized.item_wh;
        delete sanitized.item_ap_id;
        delete sanitized.item_Spec;
        delete sanitized.item_sprice_use;
        delete sanitized.item_id;

        return sanitized;
      };

      const where = { item_id: formData.item_id };
      const values = sanitizeData(formData); // <== ใช้ตัวเดียวกับ insert

      const res = await updateData("Tb_Set_Item", values, where);
      const createdBy = localStorage.getItem("name");

      if (showSubItemTable) {
        // โหลด BOM เดิมจาก DB ก่อนเปรียบเทียบ
        const oldBOM = await getDataWithComp(
          "Tb_Set_ItemBOM",
          `AND pro_id = ${formData.item_id}`
        );

        if (isBOMListChanged(oldBOM, formDetailList)) {
          await deleteData(
            "Tb_Set_ItemBOM",
            `WHERE pro_id = ${formData.item_id}`
          );
          await insertItemBOMList(formData.item_id, createdBy);
        }
      }
      if (showSubItemTable2) {
        const oldSubList = await getDataWithComp(
          "Tb_Set_ItemSub",
          `AND item_id = ${formData.item_id}`
        );

        if (isSubListChanged(oldSubList, formDetailList)) {
          await deleteData(
            "Tb_Set_ItemSub",
            `WHERE item_id = ${formData.item_id}`
          );
          console.debug("formDetailList", formDetailList);
          await insertItemSubList(
            formData.item_id,
            formDetailList[0].itemId,
            createdBy
          );
        }
      }

      if (res?.status === "OK") {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถอัปเดตข้อมูลได้");
      }
      return res;
    } catch (error) {
      console.error("Error updating item:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return { status: "FAILED", message: error.message };
    }
  };

  const isBOMListChanged = (oldList, newList) => {
    if (oldList.length !== newList.length) return true;

    for (let i = 0; i < oldList.length; i++) {
      const oldItem = oldList[i];
      const newItem = newList.find((n) => n.itemId === oldItem.itemId);

      if (!newItem) return true;

      const oldQty = parseFloat(oldItem.quantity || 0);
      const newQty = parseFloat(
        parseCurrency(newItem.itemQty?.toString().replace(/,/g, "") || "0")
      );

      if (oldQty !== newQty) return true;
    }

    return false;
  };

  const isSubListChanged = (oldList, newList) => {
    if (oldList.length !== newList.length) return true;

    for (let i = 0; i < oldList.length; i++) {
      const oldItem = oldList[i];
      const newItem = newList.find((n) => n.itemId === oldItem.subitem_id);

      if (!newItem) return true;

      const oldQty = parseFloat(oldItem.subitem_qty || 0);
      const newQty = parseFloat(
        parseCurrency(newItem.itemQty?.toString().replace(/,/g, "") || "0")
      );

      if (oldQty !== newQty) return true;
    }

    return false;
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Item",
            `WHERE Item_Id = ${selectedData.Item_Id}`
          );
          await deleteData(
            "Tb_Set_ItemBOM",
            `WHERE pro_id = ${selectedData.Item_Id}`
          );
          await deleteData(
            "Tb_Set_ItemSub",
            `WHERE item_id = ${selectedData.Item_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      });
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const checkItemCodeDuplicate = async (itemCode, excludeId = null) => {
    try {
      let where = `Item_Code = '${itemCode}'`;
      if (excludeId) {
        where += ` AND Item_Id != ${excludeId}`;
      }
      const resItemCode = await getData("Tb_Set_Item", where);
      return resItemCode && resItemCode.length > 0;
    } catch (error) {
      console.error("Error checking item code:", error);
      return false;
    }
  };

  const SaveAS = async () => {
    try {
      // ตรวจสอบว่ารหัสสินค้าปัจจุบันซ้ำหรือไม่
      const isDuplicate = await checkItemCodeDuplicate(formData.item_code);

      if (isDuplicate) {
        // ถ้าซ้ำให้แสดง modal ให้กรอกรหัสใหม่
        setNewItemCode(formData.item_code + "_COPY");
        setShowItemCodeModal(true);
        return;
      }

      // ถ้าไม่ซ้ำให้ดำเนินการ SaveAS ต่อไป
      await performSaveAS(formData.item_code);
    } catch (error) {
      console.error("Error in SaveAS:", error);
      getAlert("FAILED", "ไม่สามารถสร้างสำเนาได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const performSaveAS = async (itemCode) => {
    try {

      // เก็บข้อมูลปัจจุบันทั้งหมดไว้ก่อน
      const currentFormData = { ...formData };
      const currentFormDetailList = [...formDetailList];
      const currentShowSubItemTable = showSubItemTable;
      const currentShowSubItemTable2 = showSubItemTable2;


      // เก็บข้อมูลไว้ใน ref
      saveAsDataRef.current = {
        formData: { ...currentFormData, item_id: null, item_code: itemCode },
        formDetailList: currentFormDetailList.map((item, index) => ({
          ...item,
          dtId: null,
          docId: null,
          line: index + 1,
        })),
        showSubItemTable: currentShowSubItemTable,
        showSubItemTable2: currentShowSubItemTable2,
      };

      // ตั้ง flag และเปลี่ยน mode
      setIsSaveAsMode(true);
      setMode("I");
      setSelectedData(null);

      getAlert("OK", `สร้างสำเนาสินค้าใหม่สำเร็จ รหัสสินค้าใหม่: ${itemCode}`);
    } catch (error) {
      console.error("Error in performSaveAS:", error);
      getAlert("FAILED", "ไม่สามารถสร้างสำเนาได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleItemCodeSubmit = async () => {
    try {
      // ตรวจสอบว่ารหัสใหม่ซ้ำหรือไม่
      const isDuplicate = await checkItemCodeDuplicate(newItemCode);

      if (isDuplicate) {
        getAlert("FAILED", "รหัสสินค้านี้มีอยู่แล้ว\nกรุณากรอกรหัสอื่น");
        return;
      }
      // ความยาวเกิน 20 ตัวอักษร
      if (newItemCode.length > 20) {
        getAlert("FAILED", "รหัสสินค้าต้องไม่เกิน 20 ตัวอักษร");
        return;
      }

      if (!newItemCode.trim()) {
        getAlert("FAILED", "กรุณากรอกรหัสสินค้า");
        return;
      }

      // ปิด modal และดำเนินการ SaveAS
      setShowItemCodeModal(false);
      await performSaveAS(newItemCode);
    } catch (error) {
      console.error("Error in handleItemCodeSubmit:", error);
      getAlert("FAILED", "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      // ตรวจสอบว่ามี quantity ที่เป็น 0 ไหม
      const zeroQtyIndex = (formDetailList ?? []).findIndex(
        (item) => parseFloat(item.itemQty || "0") === 0
      );

      if (zeroQtyIndex !== -1) {
        getAlert(
          "WARNING",
          `แถวที่ ${zeroQtyIndex + 1} มีจำนวนสินค้าเป็น 0 กรุณาแก้ไขก่อนบันทึก`
        );
        return; // ยกเลิกการบันทึกทันที
      }

      // บันทึกตาม mode
      let newItemId = null;
      let result = { status: "FAILED" };

      if (mode === "I") {
        const res = await handleInsertTbsetItem();
        result = res;
        if (res?.status === "OK") {
          newItemId = res?.result?.recordset?.[0]?.insertedId;
          // ดึง WH_Id จาก whDataList ด้วยชื่อคลังที่เลือก
          const selectedWarehouse = whDataList.find(
            (wh) => wh.WH_Name === formData.item_wh
          );
          const warehouseId = selectedWarehouse?.WH_Id;

          // เฉพาะชื่อคลังที่ต้องการเท่านั้น
          const allowedNames = ["คลังสินค้า", "คลังผลิต", "คลังอุปกรณ์"];
          if (
            warehouseId &&
            allowedNames.includes(selectedWarehouse?.WH_Name)
          ) {
            await manageWhItemData(
              newItemId,
              formData.item_code,
              formData.item_name,
              warehouseId,
              "BG",
              0,
              null,
              "เริ่มต้นคลัง",
              "เริ่มต้นคลัง",
              null
            );
          }
        }
      } else if (mode === "U") {
        const res = await handleUpdateTbsetItem();
        result = res;
      }

      if (result?.status === "OK") {
        await callInitialize();

        // เคลียร์ form หลังบันทึก
        setFormData({
        item_id: "", // Int
        comp_id: parseInt(window.localStorage.getItem("company"), 10),
        item_barcode: "",
        item_code: "",
        item_name: "",
        item_name_en: "",
        item_short_name: "",
        item_unit_in: "",
        item_unit_st: "",
        item_unit_out: "",
        item_cost: "",
        item_price: "",
        item_pricea: "",
        item_priceb: "",
        item_brand: "",
        item_series: "",
        item_group: "",
        item_cat: "",
        item_colour: "",
        item_size: "",
        item_status: "Y",
        item_popoint: "",
        item_maxonhand: "",
        ap_code: "",
        item_gold: "",
        item_onhand: "",
        item_wh: "",
        item_ap_id: "",
        item_Spec: null,
        is_bom: null,
        is_sub_item: null,
        show_spec: null,
        item_qty_in: null,
        item_qty_st: null,
        item_qty_out: null,
      });
      } // End if result.status === "OK"
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
    }
  };

  const checkItemCode = async () => {
    // ถ้าอยู่ในโหมด SaveAS ไม่ต้องตรวจสอบซ้ำ
    if (isSaveAsMode) {
      return;
    }

    if (!formData.item_code) return;

    const isDuplicate = await checkItemCodeDuplicate(
      formData.item_code,
      mode === "U" ? formData.item_id : null
    );

    if (isDuplicate) {
      getAlert("FAILED", "มีรหัสสินค้านี้อยู่ในระบบแล้ว");
      // setFormData((prev) => ({ ...prev, item_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสสินค้านี้สามารถใช้ได้");
    }
  };

  const options = apDataList
    .slice() // ป้องกันไม่ให้แก้ของเดิม
    .sort((a, b) => a.AP_Id - b.AP_Id) // เรียงจากน้อยไปมาก
    .map((ap) => ({
      value: ap.AP_Id,
      label: `${ap.AP_Code}-${ap.AP_Name}`,
    }));

  const optiongroupDataList = groupDataList
    .slice() // ป้องกันไม่ให้แก้ของเดิม
    .sort((a, b) => a.Group_Id - b.Group_Id)
    .map((p) => ({
      value: p.Group_Id,
      label: `${p.Group_Name}`,
    }));

  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      console.debug("selectedItem", itemsSelected);

      setFormDetailList((prev) => {
        const itemsFromOnRowSelectItem02 = prev.filter(
          (item) => item.itemId === null
        );
        const existingItems = prev.filter((item) => item.itemId !== null);

        // ตรวจสอบว่า itemId นี้มีอยู่แล้วหรือยัง
        const newItems = itemsSelected
          .filter(
            (selectedItem) =>
              !existingItems.some(
                (existingItem) => existingItem.itemId === selectedItem.Item_Id
              )
          )
          .map((selectedItem) => ({
            line: null,
            itemId: selectedItem.Item_Id,
            itemCode: selectedItem.Item_Code,
            itemName: selectedItem.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: selectedItem.Item_Unit_ST,
            itemPriceUnit: formatCurrency(selectedItem.Item_Price || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: selectedItem.Item_Status,
            whId: null,
            whName: selectedItem.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
          }));

        // ✅ ไม่ลบของเก่า: รวมของเก่า + แถวเปล่า + รายการใหม่ที่ยังไม่มี
        return [...existingItems, ...itemsFromOnRowSelectItem02, ...newItems];
      });

      handleItemClose();
    } catch (error) {
      console.error("onRowSelectItem error:", error);
      getAlert("FAILED", "เกิดข้อผิดพลาด");
    }
  };

  const handleRemoveRow = (index) => {
    setFormDetailList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const handleChangeDetail = (index, key, value) => {
    setFormDetailList((prevList) => {
      const updatedList = [...prevList];
      updatedList[index] = {
        ...updatedList[index],
        [key]: value,
      };
      return updatedList;
    });
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    const value = updatedList[index][field];

    let parsed = 0;

    if (typeof value === "string") {
      parsed = parseCurrency(value.replace(/,/g, ""));
    } else if (typeof value === "number") {
      parsed = value;
    } else if (value != null && typeof value.toString === "function") {
      parsed = parseCurrency(value.toString().replace(/,/g, ""));
    }

    updatedList[index][field] = parsed || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };
  const handlecheckbox = (name, checked) => {
    if (name === "is_sub_item") {
      setFormData({
        ...formData,
        is_sub_item: checked,
        is_bom: checked ? false : formData.is_bom,
      });
    } else if (name === "is_bom") {
      setFormData({
        ...formData,
        is_bom: checked,
        is_sub_item: checked ? false : formData.is_sub_item,
      });
    }
  };

  // // useEffect สำหรับรีเซ็ต SaveAs flags
  // useEffect(() => {
  //   // เมื่อ SaveAs เสร็จแล้ว ให้รีเซ็ต flags
  //   if (saveAsCompleted) {
  //     console.log("=== SaveAs เสร็จแล้ว - รีเซ็ต flags ===");
  //     setTimeout(() => {
  //       setIsSaveAsMode(false);
  //       setSaveAsCompleted(false);
  //     }, 200);
  //   }
  // }, [saveAsCompleted]);

  useEffect(() => {

    // ถ้ามีข้อมูล SaveAS ให้ใช้ข้อมูลนั้น
    if (isSaveAsMode && saveAsDataRef.current && mode === "I") {
      const { formData: savedFormData, formDetailList: savedFormDetailList, showSubItemTable: savedShowSubItemTable, showSubItemTable2: savedShowSubItemTable2 } = saveAsDataRef.current;


      // ใช้ setTimeout เพื่อให้ state อัปเดตเรียบร้อย
      setTimeout(() => {
        setFormData(savedFormData);
        setFormDetailList(savedFormDetailList);
        setShowSubItemTable(savedShowSubItemTable);
        setShowSubItemTable2(savedShowSubItemTable2);
        setInitialFormData(savedFormData);

        console.log("ตั้งค่าข้อมูลเสร็จแล้ว");

        // ล้างข้อมูลใน ref และแสดงผลสำเร็จ
        saveAsDataRef.current = null;
        setSaveAsCompleted(true);
      }, 100);

      // โหลด master data
      initialize();
      return;
    }

    // ถ้ากำลังอยู่ในโหมด SaveAS แต่ยังไม่พร้อม ให้รอ
    if (isSaveAsMode) {
      return;
    }

    if (mode === "I") {
      // รีเซ็ตข้อมูลใหม่สำหรับการสร้างใหม่ปกติ
      const initialData = {
        item_id: "", // Int
        comp_id: parseInt(window.localStorage.getItem("company"), 10),
        item_barcode: "",
        item_code: "",
        item_name: "",
        item_name_en: "",
        item_short_name: "",
        item_unit_in: "",
        item_unit_st: "",
        item_unit_out: "",
        item_cost: "",
        item_price: "",
        item_pricea: "",
        item_priceb: "",
        item_brand: "",
        item_series: "",
        item_group: "",
        item_cat: "",
        item_colour: "",
        item_size: "",
        item_status: "Y",
        item_popoint: "",
        item_maxonhand: "",
        ap_code: "",
        item_gold: "",
        item_onhand: "",
        item_wh: "",
        item_ap_id: "",
        item_Spec: null,
        is_bom: null,
        is_sub_item: null,
        show_spec: null,
        item_qty_in: 1,
        item_qty_out: 1,
        item_qty_st: 1,
      };
      initialize();
      setFormData(initialData);
      setInitialFormData(initialData);
      setFormDetailList([]); // รีเซ็ตรายการย่อย
      setShowSubItemTable(false);
      setShowSubItemTable2(false);
    } else if (mode === "U" && selectedData) {
      const initialData = {
        item_id: parseInt(selectedData.Item_Id, 10),
        comp_id: parseInt(selectedData.Comp_Id, 10),
        item_barcode: selectedData.Item_Barcode,
        item_code: selectedData.Item_Code,
        item_name: selectedData.Item_Name,
        item_name_en: selectedData.Item_Name_EN,
        item_short_name: selectedData.Item_Short_Name,
        item_unit_in: selectedData.Item_Unit_IN,
        item_unit_st: selectedData.Item_Unit_ST,
        item_unit_out: selectedData.Item_Unit_OUT,
        item_cost: selectedData.Item_Cost,
        item_price: selectedData.Item_Price,
        item_pricea: selectedData.Item_PriceA,
        item_priceb: selectedData.Item_PriceB,
        item_brand: selectedData.Item_Brand,
        item_series: selectedData.Item_Series,
        item_group: selectedData.Item_Group,
        item_cat: selectedData.Item_Cat,
        item_colour: selectedData.Item_Colour,
        item_size: selectedData.Item_Size,
        item_status: selectedData.Item_Status,
        item_popoint: parseInt(selectedData.Item_PoPoint, 10),
        item_maxonhand: parseInt(selectedData.Item_MaxOnhand, 10),
        ap_code: selectedData.AP_Code,
        item_gold: parseInt(selectedData.Item_Gold),
        item_onhand: parseInt(selectedData.Item_Onhand, 10),
        item_wh: selectedData.Item_WH,
        item_ap_id: selectedData.Item_AP_id,
        item_Spec: selectedData?.Item_Spec,
        is_bom: selectedData?.Is_BOM === "Y" ? true : false,
        is_sub_item: selectedData?.Is_Sub_Item === "Y" ? true : false,
        show_spec: selectedData?.Is_Spec_Show === "Y" ? true : false,
        item_qty_in: selectedData?.Item_Qty_IN,
        item_qty_out: selectedData?.Item_Qty_Out,
        item_qty_st: selectedData?.Item_Qty_ST,
      };
      initialize();
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData, isSaveAsMode]);

  useEffect(() => {
    // ข้ามการตรวจสอบถ้าข้อมูลยังไม่โหลดครบ หรือกำลังอยู่ในโหมด SaveAS
    if (!initialFormData || Object.keys(initialFormData).length === 0 || isSaveAsMode) {
      return;
    }

    const isGroupChanged =
      mode === "U" &&
      formData.is_bom !== initialFormData.is_bom &&
      formData.is_bom !== true &&
      formDetailList.length > 0;

    if (isGroupChanged) {
      getAlert(
        "C_DIALOG",
        "การเปลี่ยนกลุ่มสินค้า จะทำให้ข้อมูล BOM หาย ต้องการเปลี่ยนจริงหรือไม่?",
        (isConfirm) => {
          if (isConfirm) {
            setFormDetailList([]);
            setShowSubItemTable(false);
            console.debug("formData.is_bom2", formData.is_bom);
          } else {
            // ยกเลิกการเปลี่ยนกลุ่มสินค้า กลับไปเป็นค่าเดิม
            setFormData((prev) => ({
              ...prev,
              is_bom: initialFormData.is_bom,
            }));
          }
        }
      );
    } else {
      console.debug("formData.is_bom1", formData.is_bom);
      const isProjectGroup = formData.is_bom === true;
      setShowSubItemTable(isProjectGroup);
    }
  }, [formData.is_bom, formDetailList.length, initialFormData, mode, setFormData, isSaveAsMode]);

  useEffect(() => {
    // ข้ามการตรวจสอบถ้าข้อมูลยังไม่โหลดครบ หรือกำลังอยู่ในโหมด SaveAS
    if (!initialFormData || Object.keys(initialFormData).length === 0 || isSaveAsMode) {
      return;
    }

    const isGroupChanged2 =
      mode === "U" &&
      formData.is_sub_item !== initialFormData.is_sub_item &&
      formData.is_sub_item !== true &&
      formDetailList.length > 0;

    if (isGroupChanged2) {
      getAlert(
        "C_DIALOG",
        "การเปลี่ยน จะทำให้ข้อมูล สินค้าหน่วยย่อหาย ต้องการเปลี่ยนจริงหรือไม่?",
        (isConfirm) => {
          if (isConfirm) {
            setFormDetailList([]);
            setShowSubItemTable2(false);
            console.debug("formData.is_sub_item", formData.is_sub_item);
          } else {
            // ยกเลิกการเปลี่ยนกลุ่มสินค้า กลับไปเป็นค่าเดิม
            setFormData((prev) => ({
              ...prev,
              is_sub_item: initialFormData.is_sub_item,
            }));
          }
        }
      );
    } else {
      console.debug("formData.is_sub_item", formData.is_sub_item);
      const isProjectGroup = formData.is_sub_item === true;
      setShowSubItemTable2(isProjectGroup);
    }
  }, [formData.is_sub_item, formDetailList.length, initialFormData, mode, setFormData, isSaveAsMode]);

  useEffect(() => {
    if (
      mode === "U" &&
      selectedData.Is_BOM === "Y" &&
      selectedData.Item_Id &&
      itemDataList.length > 0
    ) {
      loadItemBOMList(selectedData.Item_Id);
      setShowSubItemTable(true);
    } else if (
      mode === "U" &&
      selectedData.Is_Sub_Item === "Y" &&
      selectedData.Item_Id &&
      itemDataList.length > 0
    ) {
      loadItemSubList(selectedData.Item_Id);
      setShowSubItemTable2(true);
    }
  }, [mode, selectedData, itemDataList]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (whDataList.length > 0 && !formData.item_wh) {
      const wh5 = whDataList.find((wh) => wh.WH_Id === 5);
      if (wh5) {
        setFormData((prev) => ({
          ...prev,
          item_wh: wh5.WH_Name,
        }));
      }
    }
  }, [whDataList, formData.item_wh, setFormData]);

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const itemCode = formData.item_code;
        if (!itemCode) {
          setOnhandMap({});
          return;
        }

        // ดึงข้อมูลเฉพาะสินค้านี้
        const rows = await getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND Item_Code = '${itemCode}'`
        );

        // group by WH_Id
        const grouped = rows.reduce((acc, r) => {
          const whId = r.WH_Id;
          const qty = Number(r.Item_Onhand ?? 0);

          if (!acc[whId]) {
            acc[whId] = 0;
          }
          acc[whId] += qty;
          return acc;
        }, {});

        console.debug("onhandMap:", grouped);
        setOnhandMap(grouped);
      } catch (error) {
        console.error("error", error);
        setOnhandMap({});
      }
    };

    fetchAmount();
  }, []);








  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/tbsetitem" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        SaveAS={SaveAS}
        mode={mode}
      />
      <div className="container p-4">
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-md-2">
                <label className="">รหัสสินค้า</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_code"
                  value={formData.item_code || ""}
                  onChange={handleChange}
                  onBlur={!isSaveAsMode ? checkItemCode : undefined}
                />
              </div>
              <div className="col-md-2">
                <label className="">Barcode</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_barcode"
                  value={formData.item_barcode || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label className="">ชื่อสินค้าแบบย่อ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_short_name"
                  value={formData.item_short_name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                {/* checkbox แนวนอน สวยงาม */}
                <div className="d-flex flex-row align-items-center gap-4 mt-2 flex-wrap">
                  <div className="form-check d-flex align-items-center gap-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="is_bom"
                      name="is_bom"
                      checked={formData.is_bom || false}
                      onChange={(e) =>
                        handlecheckbox("is_bom", e.target.checked)
                      }
                    />
                    <label
                      className="form-check-label"
                      style={{ width: "5px" }}
                      htmlFor="is_bom"
                    >
                      BOM
                    </label>
                  </div>

                  {/* <div className="form-check d-flex align-items-center gap-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="is_sub_item"
                      name="is_sub_item"
                      checked={formData.is_sub_item || false}
                      onChange={(e) =>
                        handlecheckbox("is_sub_item", e.target.checked)
                      }
                    />
                    <label
                      className="form-check-label"
                      style={{ width: "50px" }}
                      htmlFor="is_sub_item"
                    >
                      สินค้ามีหน่วยย่อ
                    </label>
                  </div> */}

                  <div className="form-check d-flex align-items-center gap-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="show_spec"
                      name="show_spec"
                      checked={formData.show_spec || false}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          show_spec: e.target.checked,
                        })
                      }
                    />
                    <label
                      className="form-check-label"
                      style={{ width: "50px" }}
                      htmlFor="show_spec"
                    >
                      Show Spec
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-4 ">
                <label className="">ชื่อสินค้า</label>
                <textarea
                  class="form-control input-spacing"
                  name="item_name"
                  rows="4"
                  style={{ width: "100%", resize: "vertical", lineHeight: 1.5 }}
                  value={formData.item_name || ""}
                  onChange={handleChange}
                />
                {/* <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_name"
                  value={formData.item_name || ""}
                  onChange={handleChange}
                /> */}
              </div>
              <div className="col-md-4">
                <label className="">ชื่อสินค้า(Supplier)</label>
                <textarea
                  class="form-control input-spacing"
                  name="item_name_en"
                  rows="4"
                  style={{ width: "100%", resize: "vertical", lineHeight: 1.5 }}
                  value={formData.item_name_en || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label className="">สเปคสินค้า(Spec)</label>
                <textarea
                  class="form-control input-spacing"
                  name="item_Spec"
                  rows="4"
                  style={{ width: "100%", resize: "vertical", lineHeight: 1.5 }}
                  value={formData.item_Spec || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3 mt-2">
                <label className="">เลือกคลัง</label>
                <div className="input-group">
                  <select
                    name="item_wh"
                    className="form-select input-spacing"
                    value={formData.item_wh || ""}
                    onChange={handleChange}
                    disabled={(whDataList || []).length <= 0}
                  >
                    <option value="">กรุณาเลือกคลัง</option>
                    {(whDataList || []).map((ware) => {
                      const whId = Number(ware.WH_Id);
                      const qty = onhandMap[whId] ?? 0;
                      return (
                        <option key={whId} value={ware.WH_Name}>
                          {ware.WH_Name} ({qty})
                        </option>
                      );
                    })}
                  </select>
                  {(whDataList || []).length <= 0 ? (
                    <div className="input-group-append">
                      <button
                        onClick={() => navigate("/tb-set-wh")}
                        className="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>


              <div className="col-md-3 mt-2">
                <label className="">แบรนด์สินค้า</label>
                <div class="input-group">
                  <select
                    name="item_brand"
                    className="form-select input-spacing"
                    value={formData.item_brand || ""}
                    onChange={handleChange}
                    disabled={brandDataList.length <= 0}
                  >
                    <option value={""}>กรุณาเลือกแบรนด์สิค้า</option>
                    {brandDataList.map((brand) => (
                      <option key={brand.Brand_id} value={brand.Brand_Code}>
                        {brand.Brand_Name}
                      </option>
                    ))}
                  </select>
                  {brandDataList.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/brand")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="col-md-3 mt-2">
                <label className="">ประเภทสินค้า(Category)</label>
                <div class="input-group">
                  <select
                    name="item_cat"
                    className="form-select input-spacing"
                    value={formData.item_cat || ""}
                    onChange={handleChange}
                    disabled={catDataList.length <= 0}
                  >
                    <option value={""}>กรุณาเลือกประเภทสินค้า</option>
                    {catDataList.map((cat) => (
                      <option key={cat.Cat_Id} value={cat.Cat_Code}>
                        {cat.Cat_Name}
                      </option>
                    ))}
                  </select>
                  {catDataList.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/tb-set-cat")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="col-md-3 mt-2">
                <label className="">กลุ่มสินค้า(Group)</label>
                <div class="input-group">
                  <Select
                    name="item_group"
                    options={optiongroupDataList}
                    value={
                      optiongroupDataList.find(
                        (opt) =>
                          parseInt(opt.value) === parseInt(formData.item_group)
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: "item_group",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    isDisabled={!groupDataList || groupDataList.length === 0}
                    styles={{
                      container: (base) => ({ ...base, width: "100%" }),
                    }}
                  />
                  {groupDataList.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/tb-set-group")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ขนาด</label>
                <div class="input-group">
                  <select
                    name="item_size"
                    className="form-select input-spacing"
                    value={formData.item_size || ""}
                    onChange={handleChange}
                    disabled={sizeDataList.length <= 0}
                  >
                    <option value={""}>กรุณาเลือกขนาดสินค้า</option>
                    {sizeDataList.map((size) => (
                      <option key={size.Size_Id} value={size.Size_Code}>
                        {size.Size_Name}
                      </option>
                    ))}
                  </select>
                  {sizeDataList.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/tb-set-size")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ข้อมูล (Series)</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="item_series"
                  value={formData.item_series || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">รหัส-ชื่อเจ้าหนี้</label>
                <Select
                  name="item_ap_id"
                  options={options}
                  value={
                    options.find(
                      (opt) =>
                        parseInt(opt.value) === parseInt(formData.item_ap_id)
                    ) || null
                  }
                  onChange={(selectedOption) =>
                    console.debug("selectedOption", selectedOption) ||
                    handleChange({
                      target: {
                        name: "item_ap_id",
                        value: selectedOption ? selectedOption.value : "",
                      },
                    })
                  }
                  isDisabled={!apDataList || apDataList.length === 0}
                  styles={{
                    container: (base) => ({ ...base, width: "100%" }),
                  }}
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "440px 380px 375px",
                  gap: "10px",
                }}
              >
                <div
                  className="mt-2"
                  style={{
                    display: "grid",
                    justifyItems: "anchor-center",
                    border: "1px dashed #c724c5",
                    padding: "10px 5px",
                  }}
                >
                  {/* หน่่วยนับ */}
                  <label
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      color: "#c724c5",
                      fontweight: "bold",
                    }}
                  >
                    ----หน่วยนับ----
                  </label>
                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "140px 75px 175px",
                      marginTop: "10px",
                      alignItems: "anchor-center",
                    }}
                  >
                    <label className="">หน่วยซื้อ</label>
                    <div>
                      <input
                        type="text"
                        className="form-control"
                        name="item_qty_in"
                        value={formData.item_qty_in || "1"}
                        onChange={handleChange}
                        disabled={unitDataList.length <= 0}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>

                    <div class="input-group" style={{ marginLeft: "20px" }}>
                      <select
                        name="item_unit_in"
                        className="form-select input-spacing"
                        value={formData.item_unit_in || "1"}
                        onChange={handleChange}
                        disabled={unitDataList.length <= 0}
                      >
                        <option value={""}>กรุณาเลือกหน่วยซื้อ</option>
                        {unitDataList.map((unit_in) => (
                          <option
                            key={unit_in.Unit_Id}
                            value={unit_in.Unit_Name}
                          >
                            {unit_in.Unit_Name}
                          </option>
                        ))}
                      </select>
                      {unitDataList.length <= 0 ? (
                        <div class="input-group-append">
                          <button
                            onClick={() => navigate("/tb-set-unit")}
                            class="btn btn-lg text-white"
                            style={{
                              padding: "12px",
                              borderRadius: "0 5px 5px 0",
                              backgroundColor: "#EF6C00",
                            }}
                            type="button"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "140px 75px 175px",
                      marginTop: "10px",
                      alignItems: "anchor-center",
                    }}
                  >
                    <label className="">
                      หน่วยสต๊อค 1 {formData.item_unit_in} =
                    </label>
                    <div>
                      <input
                        type="text"
                        className="form-control"
                        name="item_qty_st"
                        value={formData.item_qty_st || "1"}
                        onChange={handleChange}
                        disabled={unitDataList.length <= 0}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                    <div class="input-group" style={{ marginLeft: "20px" }}>
                      <select
                        name="item_unit_st"
                        className="form-select input-spacing"
                        value={formData.item_unit_st || ""}
                        onChange={handleChange}
                        disabled={unitDataList.length <= 0}
                      >
                        <option value={""}>กรุณาเลือกหน่วยสต๊อค</option>
                        {unitDataList.map((unit_st) => (
                          <option
                            key={unit_st.Unit_Id}
                            value={unit_st.Unit_Name}
                          >
                            {unit_st.Unit_Name}
                          </option>
                        ))}
                      </select>
                      {unitDataList.length <= 0 ? (
                        <div class="input-group-append">
                          <button
                            onClick={() => navigate("/tb-set-unit")}
                            class="btn btn-lg text-white"
                            style={{
                              padding: "12px",
                              borderRadius: "0 5px 5px 0",
                              backgroundColor: "#EF6C00",
                            }}
                            type="button"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "140px 75px 175px",
                      marginTop: "10px",
                      alignItems: "anchor-center",
                    }}
                  >
                    <label className="">
                      หน่วยขาย 1 {formData.item_unit_in} =
                    </label>
                    <div>
                      <input
                        type="text"
                        className="form-control"
                        name="item_qty_out"
                        value={formData.item_qty_out || "1"}
                        onChange={handleChange}
                        disabled={unitDataList.length <= 0}
                        style={{ marginLeft: "10px" }}
                      />
                    </div>
                    <div class="input-group" style={{ marginLeft: "20px" }}>
                      <select
                        name="item_unit_out"
                        className="form-select input-spacing"
                        value={formData.item_unit_out || ""}
                        onChange={handleChange}
                        disabled={unitDataList.length <= 0}
                      >
                        <option value={""}>กรุณาเลือกหน่วยขาย</option>
                        {unitDataList.map((unit_st) => (
                          <option
                            key={unit_st.Unit_Id}
                            value={unit_st.Unit_Name}
                          >
                            {unit_st.Unit_Name}
                          </option>
                        ))}
                      </select>
                      {unitDataList.length <= 0 ? (
                        <div class="input-group-append">
                          <button
                            onClick={() => navigate("/tb-set-unit")}
                            class="btn btn-lg text-white"
                            style={{
                              padding: "12px",
                              borderRadius: "0 5px 5px 0",
                              backgroundColor: "#EF6C00",
                            }}
                            type="button"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="mt-2"
                  style={{
                    display: "grid",
                    justifyItems: "anchor-center",
                    border: "1px dashed #c724c5",
                    padding: "10px 5px",
                  }}
                >
                  {/* ราคาขาย */}
                  <label
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      color: "#c724c5",
                      fontweight: "bold",
                    }}
                  >
                    ----ราคาขาย----
                  </label>
                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 220px",
                      marginTop: "10px",
                    }}
                  >
                    <label className="">ราคาขาย1</label>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px auto ",
                        gap: "60px",
                        alignItems: "baseline",
                      }}
                    >
                      <CurrencyInput
                        maxLength={15}
                        decimalsLimit={2}
                        decimalScale={2}
                        allowNegativeValue={false}
                        className="form-control input-spacing text-end"
                        name="item_price"
                        value={formData.item_price || ""}
                        onValueChange={(value, name) =>
                          handleCurrencyChange(value, name)
                        }
                      />
                      <p style={{ width: "100%" }}>
                        ต่อ {formData.item_unit_out}
                      </p>
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 220px",
                      marginTop: "10px",
                    }}
                  >
                    <label className="">ราคาขาย2</label>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px auto ",
                        gap: "60px",
                        alignItems: "baseline",
                      }}
                    >
                      <CurrencyInput
                        maxLength={15}
                        decimalsLimit={2}
                        decimalScale={2}
                        allowNegativeValue={false}
                        className="form-control input-spacing text-end"
                        name="item_pricea"
                        value={formData.item_pricea || ""}
                        onValueChange={(value, name) =>
                          handleCurrencyChange(value, name)
                        }
                      />
                      <p style={{ width: "100%" }}>
                        ต่อ {formData.item_unit_out}
                      </p>
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 220px",
                      marginTop: "10px",
                    }}
                  >
                    <label className="">ราคาขาย3</label>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px auto ",
                        gap: "60px",
                        alignItems: "baseline",
                      }}
                    >
                      <CurrencyInput
                        maxLength={15}
                        decimalsLimit={2}
                        decimalScale={2}
                        allowNegativeValue={false}
                        className="form-control input-spacing text-end"
                        name="item_priceb"
                        value={formData.item_priceb || ""}
                        onValueChange={(value, name) =>
                          handleCurrencyChange(value, name)
                        }
                      />
                      <p style={{ width: "100%" }}>
                        ต่อ {formData.item_unit_out}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="mt-2"
                  style={{
                    display: "grid",
                    justifyItems: "anchor-center",
                    border: "1px dashed #c724c5",
                    padding: "10px 5px",
                  }}
                >
                  {/* กำหนดค่า */}
                  <label
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      color: "#c724c5",
                      fontweight: "bold",
                    }}
                  >
                    ----กำหนดค่า----
                  </label>
                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 220px",
                      marginTop: "10px",
                    }}
                  >
                    <label className="">ต้นทุน</label>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px auto ",
                        gap: "60px",
                        alignItems: "baseline",
                      }}
                    >
                      <CurrencyInput
                        maxLength={15}
                        decimalsLimit={2}
                        decimalScale={2}
                        allowNegativeValue={false}
                        className="form-control input-spacing text-end"
                        name="item_cost"
                        value={formData.item_cost || ""}
                        onValueChange={(value, name) =>
                          handleCurrencyChange(value, name)
                        }
                      />
                      <p style={{ width: "100%" }}>
                        ต่อ {formData.item_unit_in}
                      </p>
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 220px",
                      marginTop: "10px",
                    }}
                  >
                    <label className="">จุดสั่งซื้อ</label>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px auto ",
                        gap: "60px",
                        alignItems: "baseline",
                      }}
                    >
                      <CurrencyInput
                        maxLength={15}
                        allowDecimals={false}
                        allowNegativeValue={false}
                        className="form-control input-spacing text-end"
                        name="item_popoint"
                        value={formData.item_popoint || ""}
                        onValueChange={(value, name) =>
                          handleCurrencyChange(value, name)
                        }
                      />
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      display: "grid",
                      gridTemplateColumns: "100px 220px",
                      marginTop: "10px",
                    }}
                  >
                    <label className="">จุดสูงสุด</label>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px auto ",
                        gap: "60px",
                        alignItems: "baseline",
                      }}
                    >
                      <CurrencyInput
                        maxLength={15}
                        allowDecimals={false}
                        allowNegativeValue={false}
                        className="form-control input-spacing text-end"
                        name="item_maxonhand"
                        value={formData.item_maxonhand || ""}
                        onValueChange={(value, name) =>
                          handleCurrencyChange(value, name)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="item_status"
                  value={formData.item_status || "Y"} // Set default value to "Y"
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>
            {showSubItemTable && (
              <ItemTable
                key={formDetailList.length}
                formDetailList={formDetailList}
                setFormDetailList={setFormDetailList}
                handleChangeDetail={handleChangeDetail}
                handleRemoveRow={handleRemoveRow}
                handleDuplicateRow={() => { }} // ถ้ายังไม่มีฟังก์ชันนี้ ไม่ต้องใส่ก็ได้
                formatCurrency={(num) => Number(num).toFixed(2)}
                showItemModal={showItemModal}
                handleItemClose={handleItemClose}
                itemDataList={itemDataList}
                onRowSelectItem={onRowSelectItem}
                onRowSelectItem02={() => { }}
                handleItemShow={handleItemShow}
                whDataList={whDataList}
                showWarehouseModal={false}
                handleWarehouseClose={() => { }}
                handleWarehouseShow={() => { }}
                onRowSelectWh={() => { }}
                handleFocus={handleFocus}
                handleBlur={handleBlur}
                disabledRec={false}
                disabled={false}
              />
            )}

            <div className="row mt-4">
              {mode !== "I" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/tbsetitem")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleSubmit()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal สำหรับกรอกรหัสสินค้าใหม่ */}
      {showItemCodeModal && (
        <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">รหัสสินค้าซ้ำ</h5>
              </div>
              <div className="modal-body">
                <p>รหัสสินค้าเดิม "{formData.item_code}"</p>
                <p>กรุณากรอกรหัสสินค้าใหม่:</p>
                <input
                  type="text"
                  className="form-control"
                  value={newItemCode}
                  onChange={(e) => setNewItemCode(e.target.value)}
                  placeholder="กรอกรหัสสินค้าใหม่"
                  maxLength={20}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowItemCodeModal(false)}
                >
                  ยกเลิก
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleItemCodeSubmit}
                >
                  ตกลง
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal backdrop */}
      {showItemCodeModal && (
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
      )}
    </form>
  );
};

export default Form;
